import styles from './toggle.less'; export {styles};

interface ToggleStyles {
    toggle?: string;
    checked?: string;
    track?: string;
    check?: string;
    cross?: string;
    thumb?: string;
}

interface ToggleProps {
    checked?: boolean;
    onChange?: (checked: boolean) => void;
    styles?: ToggleStyles;
}

interface ToggleState {
    checked: boolean;
}

export default class Toggle extends React.PureComponent<ToggleProps, ToggleState> {

    constructor(props) {
        super(props);

        this.state = {checked: !!this.props.checked};
        this.onClick = this.onClick.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.checked !== this.props.checked) {
            this.setState({checked: !!this.props.checked});
        }
    }

    onClick() {
        this.setState((prevState) => {
            return {checked: !prevState.checked};
        }, () => {
            this.props.onChange?.(this.state.checked);
        });
    }

    render() {
        return (
            <div className={classNames(styles.toggle, this.props.styles?.toggle, {[styles.checked]: this.state.checked}, {[this.props.styles?.checked]: this.state.checked})} onClick={this.onClick}>
                <div className={classNames(styles.track, this.props.styles?.track)}>
                    <div className={classNames(styles.check, this.props.styles?.check)}/>
                    <div className={classNames(styles.cross, this.props.styles?.cross)}/>
                </div>
                <div className={classNames(styles.thumb, this.props.styles?.thumb)}/>
            </div>
        );
    }
}
